import React from 'react'
import { formatSecondsAsDays } from 'shared/column-filters/timeInQueueUnit'

// Renders a seconds-valued column as days (e.g. "2 days"). The raw seconds
// value is exposed on hover so a user can verify the precise number.
function TimeInQueueCell({ value }) {
  if (value === null || value === undefined || value === '') {
    return <td className="align-middle text-muted fw-light"></td>
  }

  const seconds = Number(value)
  if (Number.isNaN(seconds)) {
    return <td className="align-middle text-muted fw-light">{String(value)}</td>
  }

  return (
    <td
      className="align-middle text-muted fw-light"
      title={`${seconds.toLocaleString()} seconds`}
    >
      {formatSecondsAsDays(seconds)}
    </td>
  )
}

export default TimeInQueueCell
